module.exports = __webpack_public_path__ + "img/widgets3.91e61a84.png";